import { createContext } from "react";
import type { IGroupsContextData, IGroupsProviderProps } from "./types";
import { createGroupUtils } from "./utils";

export const GroupsContext = createContext<IGroupsContextData | null>(null);

export const GroupsProvider = ({ children }: IGroupsProviderProps) => {

  const contextValue: IGroupsContextData = {
    ...createGroupUtils(),
  };

  return (
    <GroupsContext.Provider value={contextValue}>
      {children}
    </GroupsContext.Provider>
  );
};
